const SCROLL_SETTLE_TIMEOUT = 800;

type ScrollTarget = Window | HTMLElement;

const getScrollTargets = (): ScrollTarget[] => {
  const targets: ScrollTarget[] = [window];
  const pageContainer = document.querySelector<HTMLElement>(
    ".app-layout__page"
  );

  if (pageContainer) targets.push(pageContainer);

  return targets;
};

const getScrollOffset = (target: ScrollTarget) => {
  if (target !== window) return (target as HTMLElement).scrollTop;

  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  );
};

const scrollTargetToTop = (target: ScrollTarget, behavior: ScrollBehavior) => {
  if (typeof target.scrollTo === "function") {
    target.scrollTo({ top: 0, left: 0, behavior });
    return;
  }

  if (target !== window) (target as HTMLElement).scrollTop = 0;
};

/**
 * Leva a página ao topo com rolagem suave e garante a chegada: a troca de
 * conteúdo pode interromper a animação do navegador e deixar a leitura parada
 * no meio. Devolve a função que cancela o acompanhamento.
 */
const scrollPageToTop = () => {
  const scrollBehavior: ScrollBehavior =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "smooth";

  const targets = getScrollTargets();

  targets.forEach((target) => scrollTargetToTop(target, scrollBehavior));

  if (
    scrollBehavior === "auto" ||
    typeof window.requestAnimationFrame !== "function"
  ) {
    return () => {};
  }

  const startedAt = Date.now();
  let previousOffsets = targets.map(getScrollOffset);
  let frame = 0;

  const ensureTop = () => {
    const offsets = targets.map(getScrollOffset);
    const pending = targets.filter((_, index) => offsets[index] > 0);

    if (pending.length === 0) return;

    // Se a página desceu, quem rolou foi o usuário: não insistimos.
    const userScrolledDown = offsets.some(
      (offset, index) => offset > previousOffsets[index]
    );

    if (userScrolledDown) return;

    if (Date.now() - startedAt >= SCROLL_SETTLE_TIMEOUT) {
      pending.forEach((target) => scrollTargetToTop(target, "auto"));
      return;
    }

    previousOffsets = offsets;
    frame = window.requestAnimationFrame(ensureTop);
  };

  frame = window.requestAnimationFrame(ensureTop);

  return () => {
    if (frame) window.cancelAnimationFrame(frame);
  };
};

export default scrollPageToTop;
